import LoadingComponent from './Loading.vue'

let $vm

export default {
  install(Vue, options) {
    if (!$vm) {
      const LoadingPlugin = Vue.extend(LoadingComponent)
      $vm = new LoadingPlugin({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    $vm.show = false

    let loading = {
      show(txt, ismask = false) {
        $vm.show = true
        $vm.ismask = ismask
        if (txt && txt.trim()) {
          $vm.text = txt
        }
      },
      hide() {
        $vm.show = false
      }
    }

    if (!Vue.$loading) {
      Vue.$loading = loading
    }

    Vue.mixin({
      created() {
        this.$loading = Vue.$loading
      },
      mounted() {
        this.$loading = Vue.$loading
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/loading/index.js